export default "__VITE_ASSET__a846ad53__"